import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { usePerformanceDetailReport } from "@/hooks/reports/performance-detail-report.hook";
import { cn } from "@/lib/utils";
import { FC, HTMLAttributes } from "react";
import { useParams } from "react-router-dom";
import RelevantTopicsCardTopic from "./relevants-topics-card-topic";

type RelevantTopicsCardProps = HTMLAttributes<HTMLDivElement>;

const RelevantTopicsCard: FC<RelevantTopicsCardProps> = ({
  className,
  ...props
}) => {
  const { data: userProfile } = useCurrentUserProfile();

  const { quizId } = useParams();

  const { data: quiz } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: quizId || "",
  });

  const {
    data: report,
    error: reportError,
    isLoading: isReportLoading,
  } = usePerformanceDetailReport({
    companyId: userProfile?.companyId || "",
    applicationQuizId: quiz?.id || "",
  });

  const highlightedTopics = report?.highlightedTopics || [];

  if (reportError) {
    throw reportError;
  }

  if (isReportLoading) {
    return (
      <Skeleton
        className={cn(className, "bg-gray-300")}
        style={{ width: "100%", height: "380px" }}
      />
    );
  }

  return (
    <Card className={cn(className, "rounded-xl px-5 py-3")} {...props}>
      <p className="mb-1 mt-2 text-xl font-bold text-[#13171B]">
        Temas relevantes
      </p>

      <p className="text-sm font-light text-[#8090A3]">
        Te presentamos el puntaje ganado en los temas con más peso dentro del
        cuestionario.
      </p>

      <div className="mb-4 mt-6 grid grid-cols-2 gap-8 lg:grid-cols-3 xl:grid-cols-5">
        {highlightedTopics.map((topic, index) => (
          <RelevantTopicsCardTopic key={index} topic={topic} />
        ))}
      </div>
    </Card>
  );
};

export default RelevantTopicsCard;
